'use strict';

var React = require('react');

var SvgMetaobjectReferenceMinor = function SvgMetaobjectReferenceMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.47 3.12a.98.98 0 0 0-.94 0l-4 2.182c-.326.178-.53.525-.53.903v5.59c0 .378.204.725.53.903l4 2.182a.98.98 0 0 0 .94 0l.53-.29v-.55c0-2.595 1.792-4.5 4-5.228v-2.607c0-.378-.204-.725-.53-.903l-4-2.182Zm8.737 5.074a1.032 1.032 0 0 0-1.414 0 .927.927 0 0 0 0 1.352l.793.759h-1.586c-2.21 0-4 1.468-4 3.279v2.596c0 .453.448.82 1 .82s1-.367 1-.82v-2.596c0-.906.895-1.366 2-1.366h1.586l-.793.758a.927.927 0 0 0 0 1.353c.39.373 1.024.373 1.414 0l2.5-2.391a.926.926 0 0 0 0-1.353l-2.5-2.391Z"
  }));
};

exports.SvgMetaobjectReferenceMinor = SvgMetaobjectReferenceMinor;
